// @flow

import React, { useCallback } from 'react';
import Button from 'react-aaui/lib/Button';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import classNames from 'classnames';

type Props = {
  selectedPresentType: string,
  onPresentTypeChange: Function,
}

const VIRTUAL = 'VIRTUAL';
const PHYSICAL = 'PHYSICAL';

const PresentTypeSwitch = ({
  selectedPresentType,
  onPresentTypeChange,
}: Props) => {
  const onChange = useCallback((noChange: boolean) => () => {
    if (!noChange) {
      onPresentTypeChange(selectedPresentType === VIRTUAL ? PHYSICAL : VIRTUAL);
    }
  }, [ selectedPresentType, onPresentTypeChange ]);

  return (
    <div className="event-home__present-type-switch">
      <Button
        onClick={onChange(selectedPresentType === PHYSICAL)}
        className={classNames(
          'event-home__present-type', {
            'event-home__present-type--selected': selectedPresentType === PHYSICAL,
          })}>
        <L10nMessage id="page.event.presentType.switch.item.physical" />
      </Button>
      <Button
        onClick={onChange(selectedPresentType === VIRTUAL)}
        className={classNames(
          'event-home__present-type', {
            'event-home__present-type--selected': selectedPresentType === VIRTUAL,
          })}>
        <L10nMessage id="page.event.presentType.switch.item.virtual" />
      </Button>
    </div>
  );
};

export default PresentTypeSwitch;
